<div class="report-model">


    <!-- <app-datatable-title [title]="'reports.propertyTransactions'" [count]="propertyTransactionCount"></app-datatable-title> -->
    <div class="report-model-header w-72">
        <div class="info">
            <h3>{{report_category === propertyCategory.VillaHouse ? ("reports.transactionHistory" | translate) :
                report_category === propertyCategory.MultiStoryOffice || report_category === propertyCategory.RetailFbAndEntertainment || report_category === propertyCategory.MultiStoryResidential? ("reports.propertyTransactions" | translate) :
                ("reports.unitTransactions" | translate)}}</h3>
            <span class="totalTransaction">({{actualCount }} {{" "+("reports.actual_transactions_with"
                |translate)+" "}} {{ quoteCount }} {{" "+("reports.quotes" | translate)+" "}}{{("reports.And" | translate)+" "}}{{ auctionCount }} {{" "+("reports.auctions" | translate)}})</span>
        </div>
    </div>

    <!-- <app-residential-detail-table
     class="default-table-view"
        [reportCategory]="report_category"
        [tableName]="'propertyTransactions'"
        [showLoader]="!propertyTransactionLoading"
        [tableColumns]="transactionPropertyColumns"
        [dataLength]="propertyTransactionCount"
        [tableData]="propertyTransactionData"
        [allowExcelDownload]="true"
        (pageEvent)="onPageEvent($event)"
        (sort)="sortData($event)"
        (excelDownload)="downloadExcel($event, 'ir_property_details_property_transactions', 'propertyTransaction')" [downloadLoading]="reportPropertyDetailService.downloadLoading['propertyTransaction']"
        [dropDownOption] = "transactionType"
        (dropDownValue)="selectionChange($event)" [resetPaginator]="resetPaginator">
    </app-residential-detail-table> -->
</div>
